import { ReadonlyRepositoryListService, Result } from '@softline/core';
import { computed, inject, Injectable } from '@angular/core';
import { BonusabfrageQuery } from '../types/bonusabfrage-query';
import { BonusabfrageQueryService } from './bonusabfrage-query.service';
import { TieredBonus } from '../types/tiered-bonus';
import { TiredBonusRepository } from '../repositories/tired-bonus.repository';

@Injectable()
export class TiredBonusService extends ReadonlyRepositoryListService<
  TieredBonus,
  Result<TieredBonus[]>,
  BonusabfrageQuery | undefined
> {
  readonly #bonusabfrageQuery = inject(BonusabfrageQueryService);

  readonly #query = computed(() => this.#bonusabfrageQuery.bonusQuery()());

  override params = computed(() => {
    return this.#query();
  });

  constructor() {
    super(inject(TiredBonusRepository));
  }

  protected override getItems(
    result: Result<TieredBonus[]> | null | undefined
  ): TieredBonus[] {
    return result as any;
  }
}
